import { LoginRequired } from "../../login/ui"
import { PlansPanelContainer } from "../../plan/ui"

export default function Page(props) {
  return (
    <LoginRequired>
      <PlansPanelContainer {...props} />
    </LoginRequired>
  )
}